import { useState, useContext, useCallback } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useContactForm = () => {
  const { api, seoApi, seobixApi } = useContext(GlobalContext);

  console.log("Seobix API Instance:", seobixApi);

  const [loading, setLoading] = useState(false);

  const postRequest = useCallback(
    async (endpoint, body) => {
      const response = await api.post(endpoint, body);
      return response?.data;
    },
    [api],
  );

  const seoPostRequest = useCallback(
    async (endpoint, body) => {
      const response = await seoApi.post(endpoint, body);
      return response?.data;
    },
    [seoApi],
  );

  const seobixPostRequest = useCallback(
    async (endpoint, body) => {
      console.log("Calling:", endpoint);
      console.log("Body:", body);

      const response = await seobixApi.post(endpoint, body);

      console.log("Axios Response:", response);

      return response?.data;
    },
    [seobixApi],
  );

  const submitContactForm = async (formData) => {
    setLoading(true);

    try {
      const payload = {
        userid: "",
        step: "1",
        step1: {
          fullName: formData.fullName,
          phoneNumber: formData.phoneNumber,
          workEmail: formData.workEmail,
          message: formData.message,
        },
      };

      const data = await postRequest("/User/v1.0/updateUserDetails", payload);

      return {
        success: true,
        data,
      };
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message || "Something went wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  const submitForm = async (formData) => {
    setLoading(true);

    try {
      const payload = {
        fullname: formData.fullName,
        email: formData.workEmail,
        website: formData.website || "",
        contact: formData.phoneNumber,
      };

      const data = await seoPostRequest("/Auth/InsertLeads", payload);

      if (data?.status === "0") {
        return {
          success: true,
          message: data?.result?.[0]?.message || "Form submitted successfully",
        };
      }

      return {
        success: false,
        message: "Submission failed. Please try again.",
      };
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message || "Something went wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  const submitEnquiryDetails = async (formData) => {
    setLoading(true);

    try {
      const payload = {
        full_name: formData.fullName || "",
        email: formData.email || "",
        enquiry_type: formData.enquiryType || "",
        description: formData.description || "",
      };

      const data = await postRequest(
        "/User/v1.0/InsertEnquiryDetails",
        payload,
      );

      return {
        success: true,
        data,
        message: data?.responseMessage || "Enquiry submitted successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Something went wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  const submitRestaurantBasicInfo = async (formData) => {
    setLoading(true);

    try {
     const payload = {
       name: formData.name || "",
       email: formData.email || "",
       phone: formData.phone || "",
       restaurant_name: formData.restaurantName || "",

       // Default values
       latitude: "28.6139",
       longitude: "77.2090",
     };


      console.log("Payload:", payload);

      const data = await seobixPostRequest(
        "/Order/insertRestaurantBasicInfo",
        payload,
      );

      console.log("Response:", data);

      if (data?.responseCode === "00") {
        return {
          success: true,
          data,
          message: data?.response?.[0]?.message || "Inserted Successfully",
        };
      }

      return {
        success: false,
        message: data?.responseMessage || "Something went wrong",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Something went wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  const getOrganizationTypes = async () => {
    try {
      const data = await postRequest("/Admin/GetOrganizationTypeAdmin", {});

      if (data?.responseCode === "00") {
        return {
          success: true,
          data: data.response || [],
        };
      }

      return {
        success: false,
        data: [],
      };
    } catch (error) {
      return {
        success: false,
        data: [],
      };
    }
  };

return {
  submitContactForm,
  submitForm,
  submitEnquiryDetails,
  submitRestaurantBasicInfo,
  getOrganizationTypes,
  loading,
};
};

export default useContactForm;